// import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import { _ } from '@feathersjs/commons'

export { default as queryOnObject } from './query'

// Type Casters
export const castArray = array => Array.isArray(array) ? array : [array]

// Type Checkers
export const isObject = _.isObject
export const isObjectOrArray = _.isObjectOrArray
export const isNumeric = value => !isNaN(parseInt(value, 10))
export const isFunction = value => typeof value === 'function'
export const isError = value => isObject(value) && (value instanceof Error || (value.code && value.name))
export const isDate = value => value instanceof Date && !isNaN(value.valueOf())
export const isDateish = value => isDate(value) ||
  (typeof value === 'string' && (value.length === 10 || value.length === 24) &&
    value.split('-').length === 3 && !isNaN(Date.parse(value)))

// --------- Strings ---------
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
export const randomString = () => Math
  .random()
  .toString(36)
  .slice(2, 15)

// ---- Data Management ----
export const getters = (...array) => mapGetters([
  'authUser',
  'hasRole',
  'isAuth',
  'isLoaded',
  'locale',
  'query',
  'queryJoin',
  ...array,
])

export const actions = (...array) => mapActions([
  // loaders
  'LOAD',
  'POST_LOAD',

  // error reporting
  'ERROR',

  // alerts
  'SUCCESS',

  // event binding
  'ON',

  // Analytics events
  ...array,
])

/*
  Adds global components. Expects components in the same form as
  vm.components. For example: { OneComponent, SomeOtherComponent }.
*/
export const registerComponents = components => Object
  .keys(components)
  .filter(componentName => !Vue.options.components[componentName])
  .forEach(componentName => Vue.component(
    componentName,
    components[componentName],
  ))

// --------- Objects & Arrays ---------
export const clone = object => JSON.parse(JSON.stringify(object))
export const merge = _.merge
export const mergeAll = ([head, ...tail]) => {
  if (!head) return {}

  return merge(head, mergeAll(tail))
}

export const getUniqueArray = array => [...new Set(castArray(array))]

export const mergeArrays = (objectsArray, labelsArray, mergeStringKey = 'label') => objectsArray
  .map((object, index) => ({
    ...object,
    ...(typeof labelsArray[index] === 'object'
      ? labelsArray[index]
      : { [mergeStringKey]: labelsArray[index] }),
  }))

export const toSum = (...keys) => (accumulator, object) =>
  accumulator + (keys.length
    ? keys.reduce((sum, key) => sum + object[key], 0)
    : object)

const sum = array => array.reduce((a, b) => a + b, 0)

export const average = array => sum(array) / array.length

export const range = (to, from = 0) => [...new Array(to).keys()].map(x => x + from)

// --------- Filtering ---------
// dot path resolver
// ({a: {b: 1}}, 'a.b') => 1
export const dot = (object, path) => path
  .split('.')
  .reduce((element, pointer) => element[pointer], object)

// --------- Promises ---------
export const chainPromises = promises => promises
  .reduce(async (previousPromise, nextPromise) => {
    await previousPromise
    return nextPromise()
  }, Promise.resolve())
